import apiClient from './apiClient';
import { AthleteSettings } from './engineService';

/**
 * `GET|PUT /api/users/me/training-settings`, mirrored from
 * `backend/modules/trainingSettings/trainingSettings.service.ts`.
 */
export interface StoredSettings extends AthleteSettings {
  confirmedAt: string | null;
  /** The specific enrollment when there is one — the id the competition-date endpoints take. */
  enrollmentId: string | null;
  planId: string | null;
  /** PRD 7 §5 / F14 — a move still ahead of the athlete, which saving will drop. */
  hasFutureMoves: boolean;
}

export const getTrainingSettings = async (): Promise<StoredSettings> =>
  (await apiClient.get('users/me/training-settings')).data;

/**
 * F6 — `includeTests` is **forbidden** by the server's schema and a 400 (`TESTS_SWITCH_LOCKED`) if
 * sent. The switch is frozen at enrollment: re-enabling it would have to re-insert a cycle already
 * behind the athlete, which is a structural change, not a replacement. Stripped here so the read-only
 * value can be carried around the screen without any risk of it reaching the wire.
 */
export const saveTrainingSettings = async (settings: AthleteSettings): Promise<StoredSettings> => {
  const body: Omit<AthleteSettings, 'includeTests'> = {
    sessionsPerWeek: settings.sessionsPerWeek,
    sportDays: settings.sportDays,
    brickDow: settings.brickDow,
    includePpg: settings.includePpg,
  };
  return (await apiClient.put('users/me/training-settings', body)).data;
};
